import type { SupportedStorage } from '@supabase/supabase-js';
import { Preferences } from '@capacitor/preferences';
import { isNative } from './platform';

const prefix = 'mindcouncil:';

export const mobileStorage: SupportedStorage = {
  getItem: async (key: string) => {
    if (!isNative()) return window.localStorage.getItem(key);
    const { value } = await Preferences.get({ key: `${prefix}${key}` });
    return value;
  },
  setItem: async (key: string, value: string) => {
    if (!isNative()) {
      window.localStorage.setItem(key, value);
      return;
    }
    await Preferences.set({ key: `${prefix}${key}`, value });
  },
  removeItem: async (key: string) => {
    if (!isNative()) {
      window.localStorage.removeItem(key);
      return;
    }
    await Preferences.remove({ key: `${prefix}${key}` });
  },
};

export async function clearNativeSessionStorage() {
  if (!isNative()) return;
  const { keys } = await Preferences.keys();
  await Promise.all(
    keys
      .filter((key) => key.startsWith(prefix) && key.includes('auth'))
      .map((key) => Preferences.remove({ key })),
  );
}
